import { cn } from '@ds';
import { formatClinicalTime } from '@features/components/ClinicalData/utils';
import { WithPerfusionTime } from '@features/components/ClinicalData/types';

type ClinicalLogItemTimeProps = {
  time: { timestamp: string; timeZone: string } | null;
  variant?: 'default' | 'danger';
};

export const ClinicalLogItemTime = ({
  time,
  perfusionTime,
  variant = 'default',
}: WithPerfusionTime<ClinicalLogItemTimeProps>) => {
  if (!time) {
    return <div />;
  }
  const clinicalRecordTime = formatClinicalTime(time.timestamp, time.timeZone);
  const baseTimeStyles = [
    'px-0.5 py-0.5 border-base-40 relative z-5 text-center bg-white text-xs-m! text-base-10',
    { 'border-danger-30 text-danger-30': variant === 'danger' },
  ];

  if (perfusionTime) {
    return (
      <div className="w-16 pt-1">
        <div className="px-0.5 py-0.5 leading-5 border-maroon-20 bg-maroon-20 border-t border-l border-r rounded-t relative z-5 text-center text-white font-semibold text-xs-m text-base-10">
          OCS {perfusionTime}
        </div>
        <div className={cn(...baseTimeStyles, 'border-b border-l border-r rounded-b')}>{clinicalRecordTime}</div>
      </div>
    );
  }

  return (
    <div className="w-16 pt-1">
      <div className={cn(...baseTimeStyles, 'border rounded')}>{clinicalRecordTime}</div>
    </div>
  );
};
